import React from 'react';
import {
  NavLink,
} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import { Hidden } from '@material-ui/core';

import { useTranslation } from 'react-i18next';

// style
import { StyledViewButton } from '../../../components/button/Button';

import { styles } from './style';
import './style.scss';

const useStyles = makeStyles(styles);
const initPath = `/${process.env.REACT_APP_PATH}`;

export default function NavForm() {
  const { t } = useTranslation();
  const classes = useStyles();
  const currentLocation = window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1);

  return (
    <div className={classes.root}>
      <Grid container direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>
        <Grid item>
          <FormControl className={classes.formControl}>
            <NavLink to={`${initPath}dam`} activeClassName="nav-active">
              <StyledViewButton
                variant={currentLocation === 'dam' ? 'contained' : 'outlined'}
                size="small"
                className={classes.btnDam}
              >
                <Hidden smUp>
                  {t('ล่าสุด')}
                </Hidden>
                <Hidden xsDown>
                  {t('ภาพรวมสถานการณ์ล่าสุด')}
                </Hidden>
              </StyledViewButton>
            </NavLink>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl className={classes.formControl}>
            <NavLink to={`${initPath}dam/large`} activeClassName="nav-active">
              <StyledViewButton
                variant={currentLocation === 'large' ? 'contained' : 'outlined'}
                size="small"
                className={classes.btnDam}
              >
                {t('สถิติแหล่งน้ำขนาดใหญ่')}
              </StyledViewButton>
            </NavLink>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl className={classes.formControl}>
            <NavLink to={`${initPath}dam/medium`} activeClassName="nav-active">
              <StyledViewButton
                variant={currentLocation === 'medium' ? 'contained' : 'outlined'}
                size="small"
                className={classes.btnDam}
              >
                {t('สถิติแหล่งน้ำขนาดกลาง')}
              </StyledViewButton>
            </NavLink>
          </FormControl>
        </Grid>
      </Grid>
    </div>
  );
}
